import { enAccount, esAccount } from './account';
import { enAgenda, esAgenda } from './agenda';
import { enAdviser, esAdviser } from './adviser';
import { enAdmin, esAdmin } from './admin';
import { enAuth, esAuth } from './auth';
import { enBilling, esBilling } from './billing';
import { enBanks, esBanks } from './banks';
import { enCommon, esCommon } from './common';
import { enCollaboration, esCollaboration } from './collaboration';
import { enDashboard, esDashboard } from './dashboard';
import { enNavigation, esNavigation } from './navigation';
import { enNotifications, esNotifications } from './notifications';
import { enOnboarding, esOnboarding } from './onboarding';
import { enPlan, esPlan } from './plan';
import { enPwa, esPwa } from './pwa';
import { enQuick, esQuick } from './quick';
import { enSupport, esSupport } from './support';
import { enTools, esTools } from './tools';
import { enWallets, esWallets } from './wallets';

export const esMessages = {
  ...esAccount,
  ...esAgenda,
  ...esAdviser,
  ...esAdmin,
  ...esAuth,
  ...esBilling,
  ...esBanks,
  ...esCommon,
  ...esCollaboration,
  ...esDashboard,
  ...esNavigation,
  ...esNotifications,
  ...esOnboarding,
  ...esPlan,
  ...esPwa,
  ...esQuick,
  ...esSupport,
  ...esTools,
  ...esWallets,
} as const;

export type TranslationKey = keyof typeof esMessages;

export const enMessages = {
  ...enAccount,
  ...enAgenda,
  ...enAdviser,
  ...enAdmin,
  ...enAuth,
  ...enBilling,
  ...enBanks,
  ...enCommon,
  ...enCollaboration,
  ...enDashboard,
  ...enNavigation,
  ...enNotifications,
  ...enOnboarding,
  ...enPlan,
  ...enPwa,
  ...enQuick,
  ...enSupport,
  ...enTools,
  ...enWallets,
} satisfies Record<TranslationKey, string>;
